export default "__VITE_ASSET__95WTG7nC__"